module.exports = __webpack_public_path__ + "static/media/wrapped-homecard-br.6f447459.jpg";